import React from "react";
import styled from "styled-components";
import ResetButton from "src/components/ResetButton";

// button that looks like a link
const Container = styled(ResetButton)`
  // link styles
  color: var(--sea);
  font-weight: 600;

  &:hover {
    color: var(--darkSea);
    text-decoration: none;
  }
`;

// inner container fixes browser inconsistencies with buttons set to `display: flex`
const InnerContainer = styled.div`
  display: flex;
  align-items: center;
`;
type ButtonLinkProps = {
  onClick: () => void;
};

const ButtonLink: React.FC<ButtonLinkProps> = ({ children, ...props }) => (
  <Container {...props}>
    <InnerContainer>{children}</InnerContainer>
  </Container>
);

export default ButtonLink;
